import { BaseDto } from './base.dto';
import { CartProductDto } from './cartProduct.dto';
import { SaleUnitCartDto } from './saleUnitCart.dto';
import { ServiceChargeDto } from './serviceCharge.dto';
import { DiscountTypeDto } from './discountType.dto';

export class SaleUnitCartSplitDto extends BaseDto {
  basketId?: string;
  identifier: number;
  saleUnitCart: SaleUnitCartDto;
  cartProducts?: CartProductDto[];
  cartTotal?: number;
  discountTypeId?: number;
  serviceChargeId?: number;
  discountType?: DiscountTypeDto;
  serviceCharge?: ServiceChargeDto;
  discountTypeAmount?: number;
  serviceChargeAmount?: number;
  totalAmount?: number;
  managerEmployeeId?: number;
  isPrintCheckPrinted?: boolean;
  paidAmount?: number;
  processingFeeAmount?: number;
}
